// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"ShuttlesEdit_pageHeader__3Z0Cd ShuttlesList_pageHeader__2iqIR","editSection":"ShuttlesEdit_editSection__fNWpX"};